import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();

  // Current page
  const currentPath = location.pathname;

  const isActive = (path) => currentPath === path;

  const baseClass =
    "flex flex-col items-center justify-center w-full pt-2 pb-3 transition-colors duration-200";

  const activeClass = "text-[#065f2a]";
  const inactiveClass = "text-gray-400 hover:text-gray-600";

  const navItems = [
    {
      to: "/subscriptions",
      label: "Today's Meals",
      icon: (
        <div className="relative mb-1">
          <svg
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 4v5h5M20 20v-5h-5"
            />

            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5.5 9A7 7 0 0118 6.5L20 9M18.5 15A7 7 0 016 17.5L4 15"
            />

            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6" />
          </svg>
        </div>
      ),
    },

    {
      to: "/home",
      label: "Home",
      icon: (
        <svg
          className="w-6 h-6 mb-1"
          fill={isActive("/home") ? "currentColor" : "none"}
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={isActive("/home") ? "0" : "2"}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
    },

    {
      to: "/profile",
      label: "Profile",
      icon: (
        <svg
          className="w-6 h-6 mb-1"
          fill={isActive("/profile") ? "currentColor" : "none"}
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="fixed bottom-0 z-30 w-full bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] pb-safe">
      <div className="flex justify-between items-center h-16 px-2">
        {navItems.map((item) => {
          const active = isActive(item.to);

          return (
            <Link
              key={item.to}
              to={item.to}
              className={`${baseClass} ${active ? activeClass : inactiveClass}`}
            >
              {item.icon}

              <span
                className={`text-[11px] tracking-wide ${
                  active ? "font-bold" : "font-semibold"
                }`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
